export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/posts${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/posts/${id}`),
    store: (data) => axios.post(`/posts`, data),
    update: (id, data) => axios.patch(`/posts/${id}`, data),
    delete: (id) => axios.delete(`/posts/${id}`),
    publish: (id, data) => axios.post(`/posts/${id}/publish`, data),
    uploadFeaturedImage: (id, data) => axios.post(`/upload-featured-image/${id}`,data),
    fileResources: (id, data) => axios.post(`/file-resources/${id}`,data),
})